import type { PersonalLawyerProfile } from "../api/client";

function maskMobile(value: string): string {
  return value.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2");
}

export function PersonalProfile({ profile }: { profile: PersonalLawyerProfile }) {
  return (
    <section className="personal-lawyer-panel" aria-label="基本资料">
      <header>
        <h1>基本资料</h1>
        <p>律师个人账号的注册信息。</p>
      </header>
      <dl className="personal-lawyer-details">
        <div><dt>律师姓名</dt><dd>{profile.lawyer_name}</dd></div>
        <div><dt>律师编号</dt><dd>{profile.lawyer_number}</dd></div>
        <div><dt>注册手机号</dt><dd>{maskMobile(profile.mobile)}</dd></div>
        <div><dt>账号类型</dt><dd>律师个人账号</dd></div>
      </dl>
    </section>
  );
}
